import type { ReactNode } from "react";
import { Banner } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";

type FormHelperBoxProps = {
    children: ReactNode;
};

/** Shared themed guidance surface for entity forms. */
export const FormHelperBox = ({ children }: FormHelperBoxProps) => {
    const theme = useTheme();

    return (
        <Box
            role="note"
            sx={{
                "& > :first-of-type": {
                    alignItems: "center",
                    paddingBlock: theme.spacing(1),
                },
            }}
        >
            <Banner
                variant="themed"
                colors={{
                    backgroundColor: theme.palette.primary[50],
                    color: theme.palette.primary[700],
                    sideBorder: theme.palette.primary[600],
                }}
            >
                {children}
            </Banner>
        </Box>
    );
};
